<template>
    <div>
        <div class="sidebar" :class="{ disabled: disabled }">
            <router-link :to="{ name: 'home' }" class="sidebar__logo">
                <img src="/static/img/logo_minimax.png" alt="Minimax Client Dashboard" title="Minimax Client Dashboard"
                    height="32px">
            </router-link>

            <template v-if="!showNavigation">
                <div class="sidebar__intro">
                    {{ $t('menu.log_in_to_view_your_account_details') }}
                </div>
            </template>
            <template v-if="showNavigation">
                <a href="#" class="nav__toggle_mobile" @click="toggleMobileMenu">

                    <span class="nav__toggle_mobile__icon">
                        <transition name="fade">
                            <i class="mdi mdi-menu" v-show="!showMobileMenu"></i>
                        </transition>
                        <transition name="fade">
                            <i v-show="showMobileMenu" class="mdi mdi-close"></i>
                        </transition>
                    </span>
                    Menu
                </a>

                <div class="sidebar__intro" v-if="authenticated">
                    <p>{{ $t('menu.welcome_to_account') }}</p>
                    <h2>{{ username }}</h2>
                </div>

                <div class="nav__setup">
                    <h4>{{ $t('menu.start') }}</h4>
                    <setup-steps></setup-steps>
                </div>

                <div class="disabled__message">
                    <p>{{ $t('menu.available_after_installation') }}</p>
                </div>

                <nav class="nav" id="nav" :class="{ 'is-active': showMobileMenu }">
                    <ul>
                        <li class="nav__item">
                            <router-link :to="{ name: 'saltblocks' }" @click="toggleMobileMenu"
                                class="nav__link">{{ $t('menu.saltblocks') }}
                                <p class="nav__item__sub">{{ $t('menu.saltblocks_sub') }}</p>
                            </router-link>
                        </li>
                        <li class="nav__item">
                            <router-link :to="{ name: 'orders' }" @click="toggleMobileMenu"
                                class="nav__link">{{ $t('menu.orders') }}
                                <p class="nav__item__sub">{{ $t('menu.orders_sub') }}</p>
                            </router-link>
                        </li>
                        <li class="nav__item">
                            <router-link :to="{ name: 'account' }" @click="toggleMobileMenu"
                                class="nav__link">{{ $t('menu.info') }}
                                <p class="nav__item__sub">{{ $t('menu.info_sub') }}</p>
                            </router-link>
                        </li>
                    </ul>
                </nav>
            </template>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { LOGOUT, IS_AUTHENTICATED } from '../../store/modules/auth';
import LocaleButton from './LocaleButton';
import SetupSteps from './SetupSteps';
import { GET_USERNAME } from '../../store/modules/account_details';
import { GET_INSTALLATION_PLACED } from '../../store/modules/proposal_progress';
import { SCREEN_SM } from '../../constants/breakpoints';

const MOBILE_CSS_CLASS = 'nav__mobile_open';
const MOBILE_CSS_TARGET = document.body.classList;

@Component({
    components: {
        LocaleButton,
        SetupSteps,
    },
    watch: {
        '$mq.resize': 'hideMobileMenu',
    }
})
export default class TheSidebar extends Vue {
    name = 'the-sidebar';
    currentPage;


    get disabled() {
        return !this.$store.getters[GET_INSTALLATION_PLACED];
    }

    created() {
        this.showMobileMenu = false;
        this.currentPage = this.$route.name;
    }

    get showMobileMenu() {
        return MOBILE_CSS_TARGET.contains(MOBILE_CSS_CLASS);
    }

    set showMobileMenu(value) {
        if (value) {
            MOBILE_CSS_TARGET.add(MOBILE_CSS_CLASS);
        } else {
            MOBILE_CSS_TARGET.remove(MOBILE_CSS_CLASS);
        }
    }

    get showNavigation() {
        return !this.$route.path.startsWith('/auth');
    }

    toggleMobileMenu() {
        if (this.$mq.below(SCREEN_SM + 1)) {
            this.showMobileMenu = !this.showMobileMenu;
        } else {
            this.showMobileMenu = false;
        }
    }

    @Watch('$mq.resize')
    hideMobileMenu() {
        if (this.$mq.above(SCREEN_SM)) {
            this.showMobileMenu = false;
        }
    }

    signOut() {
        this.$store.dispatch(LOGOUT).then(() => {
            this.$router.replace({
                name: 'sign-in'
            });
        });
    }

    get authenticated() {
        return this.$store.getters[IS_AUTHENTICATED];
    }

    get username() {
        return this.$store.getters[GET_USERNAME];
    }
}
</script>



// WEBPACK FOOTER //
// src/components/general/TheSidebar.vue